<div class="page-container">
    <h2 class="text-center">Scegli l'agenzia che vuoi modificare</h2>

    <div class="agenzie-list">
        <a class="agenzia" *ngFor="let soc of auth.user.societa" routerLink="/anagrafica-societa/{{soc.id}}">
            {{soc.ragioneSociale}}
        </a>
    </div>
</div>
